import "../app-toast.js";

export function toast(message, type = "info") {
    const container = document.getElementById("toast-container");
    if (!container) {
        console.error("Toast-Container fehlt!");
        return;
    }

    const element = document.createElement("app-toast");
    element.message = message;
    element.type = type;
    container.appendChild(element);
}